module.exports = __webpack_public_path__ + "img/action_2nd.836632e.png";